import { Box, MenuItem, TextField } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import ClearButton from "components/buttons/ClearButton";
import SearchButton from "components/buttons/SearchButton";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { driverApiNm } from "constants/driverConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { addIdForDataGrid } from "utils";
import { columns } from "./columns";  
import { branchApiNm } from "branch/constant/branchApiNm";

const initFilterData = { IsActv: 1, Name: null, IsSub: 0 }
let lastFilter = null
const DriverExpress = () => {
  const {ax} = useContext(GlobalStateContext)

  const [filterData, setFilterData] = useState(initFilterData)
  const [dataTable, setDataTable] = useState([])

  const getData = useCallback((filter)=>{
    ax.post(branchApiNm.getDriverExpressData, filter).then(value=>{
      if(value.data){
        setDataTable(addIdForDataGrid(value.data, "DrvId"))
        lastFilter = filter
      }
    })
  }, [ax])
  
  const filterProps = useCallback((name) => ({
    variant: 'outlined',
    size: 'small',
    name: name,
    value: filterData[name] === null? '': filterData[name],
    onKeyUp: e => {if(e.code === "Enter" || e.code === "NumpadEnter"){getData(filterData)} }, 
    onChange: (e) => { setFilterData(oldState => ({ ...oldState, [name]: e.target.value === ""?null: e.target.value })) }
  }), [filterData, getData])


  const handleEditCommit = useCallback((params)=>{
    if(params.field === "XpssSupCod") {

      const postData = {
        ColValues : {
          XpssSupCod: params.value
        },
        DrvId: params.id,
        getArgs: lastFilter
      }
      ax.post(driverApiNm.updateDriverColumn, postData, false).then(value=>{
        if(value.data){
          // Do nothing
          // setDataTable(addIdForDataGrid(value.data, "DrvId"))
        }
      })
    }
  }, [ax])

  useEffect(()=>{
    getData(initFilterData)
  }, [getData])
  return (
    <BoxFC height="100%">
      <BoxFR>
        <Box flex={1} />
        <TextField label="Active" size="small" select value={filterData.IsActv || ""}
          onChange={(e) => { setFilterData(o => ({ ...o, IsActv: e.target.value })) }}>
          <MenuItem value={null}>ไม่ระบุ</MenuItem>
          <MenuItem value={1}>Active</MenuItem>
          <MenuItem value={0}>Inactive</MenuItem>
        </TextField>
        <TextField {...filterProps('Name')} label="ชื่อ-นามสกุล-ชื่อเล่น" />
        <SearchButton onClick={()=>{getData(filterData)}}/>
        <ClearButton onClick={() => { setFilterData(initFilterData) }} />
      </BoxFR>
      <Box flex={1} >
        <DataGridCellExpand
          hideFooter
          rows={dataTable}
          columns={columns}
          onCellEditCommit={handleEditCommit}
        />
      </Box>

    </BoxFC>
  )
}

export default DriverExpress;